import React, {useCallback, useEffect, useRef, useState} from "react";
import styled from "styled-components";

const SNotifications = styled.div`
    width: 30%;
    height: calc(100dvh - 30px);
    padding-left: 45px;
    z-index: 100;
    position: absolute;
    right: 0;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    overflow: hidden;
    
    .notification-container {
        width: calc(100% - 59px);
        margin-left: 460px;
        transition: 0.6s margin-left, 0.4s opacity;
        padding: 15px;
        padding-left: 24px;
        
        background: rgb(255 255 255 / 6%);
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(10.9px);
        border-radius: 10px;
        margin-top: 20px;
        font-family: SF;
        font-size: 18px;
    }
    
    .notification-container > p {
        margin: 0;
        margin-left: 10px;
    }
    
    .notification-container > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .notification-container > div > p {
        font-weight: 600;
        margin: 0;
        margin-bottom: 12px;
    }
    
    .notification-track img {
        height: 80px;
        border-radius: 8px;
        margin-right: 15px;
        box-shadow: 0 0 3px #00000063;
    }
    
    .notification-track {
        display: flex;
        align-items: center;
    }
    
    .notification-track > div {
        display: flex;
        flex-direction: column;
        height: 60px;
    }
    
    .notification-track > div > div {
        font-size: 16px;
    }
    
    .notification-track .not-track-artist {
        font-weight: 400;
        font-size: 20px;
        margin-bottom: 5px;
    }
    
    .notification-track .not-track-title {
        font-size: 18px;
        opacity: 0.6;
        font-weight: 300;
    }
    
    
    .side-icon {
        display: flex;
        width: 90px;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
    }
    
    .side-icon img {
        filter: invert(1);
        opacity: 0.4;
        height: 60px;
    }
    
    .left-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-height: 100px;
        width: 100%;
    }
    
    .lc-medium {
        min-height: 80px;
    }
    
    .lc-small {
        min-height: unset;
    }
    
    .notification-header {
        font-size: 20px;
        margin-top: 10px;
        opacity: 0.6;
        font-weight: 200;
    }
    
    .n-text {
        font-weight: 600;
        font-size: 30px;
        margin-top: 10px;
    }
    
    .n-big-text {
        align-self: center;
        font-size: 32px;
        letter-spacing: 3px;
        font-weight: 200;
        margin-left: 10px;
    }
    
    .n-big-text > span {
        font-size: 54px;
    }
    
    .notification-body:has(> .n-big-text) {
        height: 100%;
    }
    
    .notification-body {
        flex-grow: 2;
        display: flex;
    }

`;

export function Notifications({lastNotification}) {
    const [last, setLast] = useState(lastNotification);
    const container = useRef(null);

    const push = (htmlContent) => {
        let cnt = document.createElement("div");
        cnt.className = "notification-container";
        cnt.innerHTML = htmlContent;
        container.current.appendChild(cnt);

        setTimeout(() => {
            cnt.style.marginLeft = "0px";
        }, 10);

        setTimeout(() => {
            cnt.style.opacity = "0";
            setTimeout(() => {
                cnt.remove();
            }, 400);
        }, 6500);
    }

    useEffect(() => {
        if (last !== lastNotification) {
            if (lastNotification?.event_type !== "new_playlist") push(get_notification_by_data(lastNotification));
            setLast(lastNotification);
        }
    }, [lastNotification]);

    return <SNotifications ref={container}>

    </SNotifications>
}


function get_notification_by_data(d) {
    const default_cover = "/icons/default_cover_large.png";

    if (d.event_type === "skip_vote") {
        return `
            <div>
                <div class="left-container lc-small">
                    <div class="notification-body">
                        <span class="n-big-text" style="white-space: nowrap; font-size: 26px;">Голос за пропуск</span>
                    </div>
                </div>
                <div class="side-icon" style="height: 50px; margin-right: -3px;">
                    <img src="/icons/skip_next_24.svg" />                    
                </div>
            </div>
        `;
    } else if (d.event_type === "track_add") {
        return `
            <div>
                <div class="left-container">
                    <div class="notification-body">
                        <div class="notification-track">
                            <img src="${d.event_data.cover || default_cover}" />
                            <div>
                                <div class="not-track-artist">${d.event_data.title}</div>
                                <div class="not-track-title">${d.event_data.artist}</div>
                            </div>
                         </div>
                    </div>
                </div>
                <div class="side-icon">
                    <img src="/icons/music_plus_24.svg" />                    
                </div>
            </div>
        `
    } else if (d.event_type === "upvote") {
        return `
            <div>
                <div class="left-container">
                    <div class="notification-body">
                        <div class="notification-track">
                            <img src="${d.event_data.cover || default_cover}" />
                            <div>
                                <div class="not-track-artist">${d.event_data.title}</div>
                                <div class="not-track-title">${d.event_data.artist}</div>
                            </div>
                         </div>
                    </div>
                </div>
                <div class="side-icon">
                    <img src="/icons/upvote_plus_24.svg" />                    
                </div>
            </div>
        `;
    } else if (d.event_type === "no_cd") {
        let postfix = d.event_data.duration < 5 ? "ы" : "";
        return `<div>
                <div class="left-container">
                    <div class="notification-header">
                        Без кулдауна
                    </div>
                    <div class="notification-body">
                    <span class="n-text">${d.event_data.duration} минут${postfix}</span>
                    </div>
                </div>
                    <div class="side-icon">
                        <img src="/icons/clock_close_outline_24.svg" />                    
                    </div>
                </div>`;
    }
}
